import DPO from 'dpo8core';
import { EndpointMap } from 'config-mapper';

DPO.dal.Request.prototype.serviceUrls = EndpointMap.getAllServicesUrls();

const endpointMap = new EndpointMap();
const targetName = endpointMap.getTarget();
const endpointName = endpointMap.getName();
const apiUrl = endpointMap.getApiUrl();

export const ep = {
  target: targetName,
  name: endpointName,
  url: apiUrl,
};

export default new DPO.dal.DAL(apiUrl, targetName);
